'use strict';

module.exports = value => {
	if (Object.prototype.toString.call(value) !== '[object Object]') {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return prototype === null || prototype === Object.prototype;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/is-plain-obj/index.js
// module id = tceQ
// module chunks = 0